const autoNgTemplateLoaderTemplate1 = require('./registry-form-azure.html');

angular.module('portainer.app').component('registryFormAzure', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '=',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
  },
});
